import { render, staticRenderFns } from "./BadgeReportSubscriptionsStatus.vue?vue&type=template&id=cd0d2a34"
import script from "./BadgeReportSubscriptionsStatus.vue?vue&type=script&lang=js"
export * from "./BadgeReportSubscriptionsStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports